document.addEventListener('DOMContentLoaded', function() {
    // swipers
    let swiperInsta = new Swiper('.swiper-insta', {
        slidesPerView: 1.2,
        speed: 1000,
        loop: true,
        spaceBetween: 0,
        centeredSlides: true,
        
        navigation: {
            prevEl: '.products .arrow-left',
            nextEl: '.products .arrow-right',
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                loop: false,
                centeredSlides: false,
            }
        }
    })
})